import React, { useState, useEffect, useCallback } from 'react'
import { PRODUCTS_SUBMENU } from 'constants/menu/submenus'
import { INITIAL_STOCK_ACTIVITY } from 'constants/objects/stock-activity'
import {
  requestStockActivitiesList,
  requestStockActivityCreate,
} from 'requests/stock-activity'
import { ListPage } from 'templates/ListPage'
import { ListSkeleton } from 'components/ListSkeleton'
import { SideMenu } from 'components/SideMenu'
import Form from 'components/StockActivity/Form/Form'
import { StockActivity } from './components/StockActivity'

export default function StockActivitiesList() {
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState()
  const [showForm, setShowForm] = useState(false)
  const [stockActivities, setStockActivities] = useState(false)
  const [responseError, setResponseError] = useState({})

  useEffect(() => {
    setShowForm(false)
  }, [])

  const getStockActivities = useCallback(async (page = 1) => {
    setLoading(true)
    const response = await requestStockActivitiesList(page)
    setLoading(false)

    setStockActivities(response.data || [])
    setPagination(response.meta?.pagination || {})
  }, [])

  useEffect(() => {
    getStockActivities()
  }, [getStockActivities])

  const onClickPagination = () => {

  }

  const onToggleForm = () => {
    setResponseError({})
    setShowForm(!showForm)
  }

  const onCreate = async (attributes) => {
    const response = await requestStockActivityCreate(attributes)
    if (response.error) return setResponseError(response)

    getStockActivities()
    return onToggleForm()
  }

  const renderForm = () => (
    <Form
      stockActivity={INITIAL_STOCK_ACTIVITY}
      onCancel={onToggleForm}
      onSave={onCreate}
      responseError={responseError}
    />
  )

  const renderLoading = () => (
    <ListSkeleton />
  )

  const renderStockActivity = (stockActivity) => (
    <StockActivity
      key={`stock-activity-${stockActivity.id}`}
      stockActivity={stockActivity}
    />
  )

  const renderList = () => {
    if (!stockActivities.length) return renderLoading()

    return stockActivities.map(renderStockActivity)
  }

  return (
    <ListPage
      renderForm={renderForm}
      renderMenu={() => <SideMenu submenu={PRODUCTS_SUBMENU} />}
      listTitle="Entrada/Saída do estoque"
      onClickPagination={onClickPagination}
      pagination={pagination}
      loading={loading}
      showForm={showForm}
      onToggleForm={onToggleForm}
      showAddButton
    >
      { renderList() }
    </ListPage>
  )
}
